import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, humanizeBytes, InfoOverlay, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { AuditStore } from '../Audit/AuditStore';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';

export interface IDocumentItemProps {
    readonly document: Mri.Documents.DocumentModel;
}

@autoinject
@observer
export class DocumentItem extends React.Component<IDocumentItemProps> {
    public render() {
        const { document } = this.props;

        return (
            <div className="card d-flex h-100">
                <div className="card-header p-2">
                    <span className="truncate d-inline-block">{document.fileName}</span>

                    <small className="float-end text-muted">{humanizeBytes(document.fileSize)}</small>
                </div>

                <div className="card-body flex-items-center justify-content-center" onMouseEnter={this.showDescription}>
                    <div className="text-center">
                        <BsFileEarmark className="f-84 mb-1" />
                        <br />
                        <InfoOverlay
                            title={document.fileName}
                            className="text-start"
                            titleInBody
                            info={document.description ?? 'No details on this file have been uploaded.'}
                        />
                    </div>
                </div>

                <div className="card-footer text-center document-footer">
                    <a className="btn btn-primary" onClick={this.download} href={document.url}>
                        Download
                    </a>
                </div>
            </div>
        );
    }

    @bind
    @action
    private showDescription(event: React.MouseEvent<HTMLDivElement>) {
        this.showing = !this.showing;
    }

    @bind
    private async download(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();

        const { fileName, url } = this.props.document;

        await this.auditStore.logDocumentDownload(fileName);

        window.location.href = url;
    }

    @observable
    private showing: boolean = false;
    @inject
    private auditStore!: AuditStore;
}
